module.exports = __webpack_public_path__ + "static/media/interest_rate.e4de2cf8.svg";